import { createGlobalStyle } from "styled-components";

// flyui Modal's DialogBody caps at 650px which causes scroll when the notification
// banner is present. styled(Modal) can't be used since Modal renders via portal and
// doesn't forward className — using createGlobalStyle scoped to the modal's open state.
export const ModalBodyFitContent = createGlobalStyle`
  div[data-testid="modal-body"][data-id="modal-body"] {
    height: fit-content;
    max-height: none;
  }
`;
